import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService } from '@app/app-config.service';
import { AuthenticationResponse, LoginService } from '@app/features/auth/services/login.service';
import { LoginStateService } from '@app/features/auth/services/login.state.service';
import { User } from '@app/shared/models/user.interface';
import { Observable } from 'rxjs';
import { SamlLogoutParameters } from '../login.saml.service';

@Injectable()
export class LoginServiceImpl implements LoginService {
  constructor(
    @Inject('LoginStateService') protected loginStateService: LoginStateService,
    protected http: HttpClient,
    protected router: Router,
    protected appConfigService: AppConfigService
  ) {}

  getUser(username: string): Observable<User> {
    return this.http.get(
      `${this.appConfigService.getApi()}/public/user/${username}?includeDisabled=false`
    ) as Observable<User>;
  }

  isUserActive(username: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.appConfigService.getApi()}/public/user/${username}/active`);
  }

  login(username: string, password: string, locale: string): Observable<AuthenticationResponse> {
    return this.http.post(`${this.appConfigService.getApi()}/auth`, { username, password, locale });
  }

  logout(): Observable<any> {
    return this.http.delete(`${this.appConfigService.getApi()}/auth/${this.loginStateService.getUsername()}`);
  }

  /**
   * @param context uuid that must be identical to the one configured in BE in order to
   * be translated into an url. Changed from being directly said url due to security reasons.
   */
  sendRecoveryUsernameMail(email: string, context: string, language: string): Observable<any> {
    return this.http.post(`${this.appConfigService.getApi()}/public/recover-username`, { email, context, language });
  }

  /**
   * @param context uuid that must be identical to the one configured in BE in order to
   * be translated into an url. Changed from being directly said url due to security reasons.
   */
  sendRecoveryPasswordMail(email: string, context: string, forgotPassword: boolean, language: string): Observable<any> {
    return this.http.post(`${this.appConfigService.getApi()}/public/recover-password`, {
      email,
      context,
      forgotPassword,
      language
    });
  }

  sendNewPassword(oldPassword: string, newPassword: string, token?: string): Observable<any> {
    return token
      ? this.http.post(`${this.appConfigService.getApi()}/public/update-password`, { token, oldPassword, newPassword })
      : this.http.post(`${this.appConfigService.getApi()}/update-password`, { oldPassword, newPassword });
  }

  loginSSO(username: string, locale: string): Observable<AuthenticationResponse> {
    return this.http.post(`${this.appConfigService.getApi()}/auth/sso`, { username, locale });
  }

  logoutSSO(username: string): Observable<any> {
    let logoutParams: SamlLogoutParameters = {
      nameId: this.loginStateService.getAdfsToken().nameId,
      user: username,
      sessionIndex: this.loginStateService.getAdfsToken().sessionIndex
    };
    //Seems that a http.post.delete can't have an object?
    return this.http.post(`${this.appConfigService.getApi()}/auth/sso/logout`, logoutParams);
  }
}
